import {
    AUTOMATIC,
    MANUAL
} from "@legacy/helpers/constants/sharedStatics";

export default {
    AUTOMATIC,
    MANUAL
};
